import { Component, OnInit } from '@angular/core';
import { UsersService } from '../../services/users.service';

@Component({
  selector: 'app-select-user',
  templateUrl: './select-user.component.html',
  styleUrls: ['./select-user.component.scss']
})
export class SelectUserComponent implements OnInit {
  loggedInUser:string = sessionStorage["puid"] != null ? sessionStorage["puid"] : null;
  usersOptions: any[] = [];
  valueField: string = 'value';
  labelField: string = 'name';
  userList:any[] = [];
  constructor(private usersService:UsersService) { }

  ngOnInit(): void {
    this.loadUsers();
  }


  loadUsers(){
    this.usersService.getUsers().subscribe(
      (usersData: any) => {
        for (var dataItem of usersData) {
          this.userList.push({
            value: dataItem.puid,
            name: `${dataItem.puid}`
          })
        }
      }
    );
  }

  setUserPUID(){
    if(this.loggedInUser != null && this.loggedInUser !== undefined && this.loggedInUser !== "")
      sessionStorage.setItem("puid", this.loggedInUser);
  }
}
